import request from '@/utils/request'



/**
 *  试卷结果列表
 * @param param
 */
export function getPaperResultList(pId) {
    return request({
        url: '/api/answer/list/' + pId,
        method: 'post'
    })
}



/**
 *  新增结果
 * @param param
 */
export function addPaperResult(query) {
    return request({
        url: '/api/answer/save',
        method: 'post',
        data:query
    })
}



/**
 *  修改结果结果
 * @param param
 */
export function editPaperResult(query) {
    return request({
        url: '/api/answer/update',
        method: 'post',
        data:query
    })
}



/**
 *  试卷结果列表
 * @param param
 */
export function deletePaperResult(aId) {
    return request({
        url: '/api/answer/delete/' + aId,
        method: 'get'
    })
}
